import styled from "styled-components";

export const StyledToastArea = styled.div`
    box-sizing: border-box;
    max-height: 100%;
    max-width: 100%;
    overflow: visible;
    padding: ${(props) => `${props.theme.spacing["8"]}`};
    position: fixed;
    z-index: ${({ theme }) => theme.elevationLevels.max};
    bottom: 0;
    left: 0;
    gap: ${(props) => `${props.theme.spacing["8"]}`};
`;
